<template>
  <div class="dashboard">
    <TitleCustom blackTitle="Dépot des" blueTitle="rapports "></TitleCustom>
  </div>
</template>

<script>
  import TitleCustom from '../components/title'

  export default {
    name: 'dashboard',
    components: { TitleCustom },
    data() {
    },
    layout(context) {
      return 'layout'
    },
    methods: {
    },
  };
</script>
